<script>
import get from 'lodash/get';
import ScrollGradient from 'sales-flow-ui/components/ScrollGradient';
import Product from 'sales-flow-ui/components/Product';
import { mapState } from 'vuex';

import config from 'config';

export default {
  components: {
    Product,
    ScrollGradient,
  },
  props: {
    category: Object,
    links: Array,
    campaigns: Array,
    utmSource: String,
  },
  data: () => ({
    config,
    get,
  }),
  computed: mapState({
    currencyInfo: state => state.currencyInfo,
  }),
};
</script>

<template lang='pug'>
.container.mt-3_25.xl_mt-5.mx-auto.pl-_5.md_px-1
  .md_border.border-brand-secondary-600.flex.flex-wrap.md_px-_75.md_pb-1_25

    .w-full.md_w-1-4.mt-1_25
      .md_p-2.ml-_375.md_mx-_5.md_bg-brand-secondary-50
        .text-4xl.md_text-3xl.text-brand-secondary-900.font-bold.leading-none.ml-1_25.md_ml-0 {{category.category}}&nbsp;
          .text-4xl.md_text-3xl.text-brand-secondary-900.font-bold.leading-none.inline-block.md_block Collection
        .mt-2.md_flex.md_justify-center.ml-_25.relative
          scroll-gradient.md_flex.md_flex-col.whitespace-no-wrap.md_whitespace-normal.overflow-x-auto.md_overflow-x-visible
            router-link.collection-button.cursor-pointer.md_font-bold.md_leading-loose.md_hover_underline.inline-block.md_block(
              v-for='link in links',
              tabindex='0',
              tag='div',
              :key='link.id',
              :to='{ name: "marketplace", query: { category: link.id }, params: { page: "1" } }',
            ) {{link.category}}
            router-link.collection-button.cursor-pointer.md_mt-2.md_hover_underline.inline-block.md_block(
              tabindex='0',
              tag='div',
              :to='{ name: "marketplace", query: { category: category.id }, params: { page: "1" } }',
            ) + #[span.md_text-brand-secondary-900 View All]

    .relative.w-full.md_w-3-4.flex
      scroll-gradient.whitespace-no-wrap.overflow-x-auto.md_overflow-x-visible.md_whitespace-normal.md_flex.w-full
        product.md_w-1-3(
          v-for='campaign in campaigns',
          :key='campaign.campaign_id',
          :campaign='campaign',
          :utm-source='utmSource',
          :affiliate='config.AFFILIATE_ID',
          :currency-info='currencyInfo',
        )
</template>

<style>
@import '~import/index';

.collection-button {
  @apply text-xl mr-_75 w-9 py-1 px-_5 truncate bg-brand-100 text-center text-brand-secondary-900;

  @media(min-width: 768px) {
    @apply w-auto py-0 text-base text-left bg-transparent text-brand;
  }
}
</style>